import { ILocation, IUnsetFields } from '../models/api/Location'
import servicesConfig, { CustomAxiosHeaders } from '../config/services'

import { AxiosResponse } from 'axios'
import { requests } from '.'

// Configure request setup
const serviceName = 'LocationsService'
const host = servicesConfig.Locations as string
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const LocationsService = {
  ids: (ids: any) => 
    request().post(`/ids`, { ids }).then(responseBody),
    
  getTags: (locationId: string) =>
    request().get(`/${locationId}/tags`).then(responseBody),
    
  search: (companyId: string, deleted: boolean, status?: string, skip?: number, limit?: number, query?: string) =>
    request().get(`/search?deleted=${deleted}&companyId=${companyId}${status ? `&status=${status}` : ''}${skip ? `&skip=${skip}` : ''}${limit ? `&limit=${limit}` : ''}${query ? `&query=${encodeURIComponent(query)}` : ''}`).then(responseBody),
    
  searchQuery: (companyId: string, deleted: boolean, query: string) =>
    request().get(`/search?deleted=${deleted}&companyId=${companyId}&query=${query ? encodeURIComponent(query) : query}&limit=50`).then(responseBody),
    
  keys: (companyId: string, deleted: boolean, status?: string, skip?: number, limit?: number) =>
    request().get(`/keys?deleted=${deleted}&companyId=${companyId}${skip ? `&skip=${skip}` : ''}${limit ? `&limit=${limit}` : ''}`).then(responseBody),
    
  keysQuery: (companyId: string, deleted: boolean, query: string) =>
    request().get(`/keys?deleted=${deleted}&companyId=${companyId}&query=${query}&limit=50`).then(responseBody),
    
  create: (body: ILocation) => 
    request().post('/', body).then(responseBody),
    
  update: (locationId: string, body: ILocation) => 
    request().put(`/${locationId}`, body).then(responseBody),

  updateES: (locationId: string, companyId: string) =>
    request().put(`/elasticsearch/${locationId}/userActivity?companyId=${companyId}`).then(responseBody),

  unsetFields: (locationId: string, body: IUnsetFields) => 
    request().put(`/${locationId}/unset-fields`, body).then(responseBody),
    
  delete: (locationId: string) => 
    request().delete(`/${locationId}`).then(responseBody),
    
  getById: (locationId: string) =>  
    request().get(`/${locationId}`).then(responseBody),
    
  Tag: {
    search: (locationId: string, query: { [key: string]: any }) => 
      request().get(`/${locationId}/tags/search${query ? '?' + new URLSearchParams(query).toString() : ''}`).then(responseBody),
  },
  
  getLabsFeatures: (type: 'location' | 'company' = 'location') => 
    request().get(`/labs/features?type=${type}`).then(responseBody),
    
  getMetaContent: (locationId: string) => 
    request().get(`/${locationId}/meta-content`).then(responseBody)
}

export default LocationsService
